export const EDITOR_TUTORIAL_COOKIE_NAME = 'lottery_editor_tutorial_visited'

export const EDITOR_TUTORIAL_COOKIE_MAX_AGE_YEARS = 1

export const EDITOR_TUTORIAL_TARGET_ATTRIBUTE = 'data-editor-tutorial-target'

export const EDITOR_TUTORIAL_OVERLAY_Z_INDEX = 1500

export const EDITOR_TUTORIAL_SPOTLIGHT_Z_INDEX = EDITOR_TUTORIAL_OVERLAY_Z_INDEX + 1

export const EDITOR_TUTORIAL_START_DELAY_MS = 150

export const EDITOR_TUTORIAL_OVERLAY_FADE_MS = 300

// Timeline from the SF-6220 dev spec. T=0 is the first completed play; the whole
// sequence runs 5.9s and then waits for the customer to dismiss it.
//   0 ms  play collapses, overlay fades in    OVERLAY_FADE_MS    300 ms
// 300 ms  swipe left + caption in             SWIPE_OUT_MS       400 ms
// 700 ms  hold                                SWIPE_HOLD_MS     1800 ms
// 2500 ms caption out, swipe back             SWIPE_BACK_MS      300 ms
// 2800 ms beat                                SWIPE_BEAT_MS      200 ms
// 3000 ms swipe right + caption in            SWIPE_OUT_MS       400 ms
// 3400 ms hold                                SWIPE_HOLD_MS     1800 ms
// 5200 ms caption out, swipe back             SWIPE_BACK_MS      300 ms
// 5500 ms beat                                SWIPE_BEAT_MS      200 ms
// 5700 ms 'Got it' fades in, both exits arm   BUTTON_FADE_MS     200 ms
export const EDITOR_TUTORIAL_SWIPE_OUT_MS = 400

export const EDITOR_TUTORIAL_SWIPE_HOLD_MS = 1800

export const EDITOR_TUTORIAL_SWIPE_BACK_MS = 300
export const EDITOR_TUTORIAL_SWIPE_BEAT_MS = 200

export const EDITOR_TUTORIAL_SWIPE_DISTANCE_PX = 105

export const EDITOR_TUTORIAL_CAPTION_FADE_MS = 200

export const EDITOR_TUTORIAL_CAPTION_GAP_PX = 16

export const EDITOR_TUTORIAL_CAPTION_OFFSET_PX = 6

export const EDITOR_TUTORIAL_ARROW_NUDGE_MS = 1000

export const EDITOR_TUTORIAL_ARROW_NUDGE_PX = 7

export const EDITOR_TUTORIAL_BUTTON_FADE_MS = 200

export const EDITOR_TUTORIAL_BUTTON_BOTTOM_PX = 180

export const EDITOR_TUTORIAL_BUTTON_HEIGHT_PX = 48

export const EDITOR_TUTORIAL_CAPTION_HEIGHT_PX = 80
